<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [areaName]="areaName"
  [columns]="columns"
  [noSubmit]="deactivateSave"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset class="tab-container">
      <ssg-tab *ngIf="isAccessToAllBranches" [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Branch' | translate">
        <editable-grid
          *ngIf="Branch && Branch?.length > 0 && model?.Branch?.length > 0 && showBranch"
          [DefaultValues]="DefaultValues"
          [columns]="Branch"
          [dataList]="model?.Branch"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
